// extracted by mini-css-extract-plugin
export default {"rating":"yB-z","numberOfStars":"zB-z","count":"AB-z","barGraphSpacing":"BB-z","barGraph":"CB-z"};